import { MouseEvent, useState } from "react";
import chevronVertical from "../../../app/images/icons/chevronVertical";
import cn from "classnames";

const RadioItem = ({
  id: key,
  value,
  helperText,
  ...rest
}: {
  id: string;
  value: string;
  helperText?: string[];
}) => {
  const [showHelperText, setShowHelperText] = useState(false);

  const handleToggleShowHelperText = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowHelperText(!showHelperText);
  };

  return (
    <>
      <div className="radio" key={key}>
        <input id={key} type="radio" {...rest} />
        <label htmlFor={key} className="radio-label">
          {value}
        </label>
        {helperText && (
          <button
            className={cn("radio__chevron", {
              radio__chevron_open: showHelperText,
            })}
            onClick={handleToggleShowHelperText}
          >
            {chevronVertical}
          </button>
        )}
      </div>
      {helperText && (
        <div
          className={cn("radio__helper", {
            radio__helper_open: showHelperText,
          })}
        >
          <div className="radio__helper-container">
            <div
              className="radio__helper-content"
              dangerouslySetInnerHTML={{
                __html: helperText.reduce(
                  (acc, line) =>
                    (acc += `<span class="typo-caption">*${line}</span>`),
                  ""
                ),
              }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default RadioItem;
